import moment from 'moment';
import BaseModel from '../Base';
import User from './User';
import Team from './Team';
import Group from './Group';
import Topic from '@/models/strategy/Topic';

export default class Membership extends BaseModel {
  static entity = 'memberships';

  static autoNormalize = [
    { model: Team, key: 'team', type: 'single' },
    { model: User, key: 'user', type: 'single' },
    { model: Group, key: 'groups', type: 'collection' }
  ];

  static fields() {
    return {
      ...super.fields(),
      isAdmin: this.boolean(false),
      level: this.string(''),
      lastFeedUpdate: this.attr('date'),
      current: this.boolean(false),
      connectUrl: this.string(''),
      user_id: this.string(''),
      team_id: this.string(''),
      user: this.belongsTo(User, 'user_id'),
      team: this.belongsTo(Team, 'team_id'),
      groups_collection: this.attr([])
    };
  }

  get groups() {
    const groups = [];

    if (this.groups_collection.length > 0) {
      this.groups_collection.forEach(groupId => {
        let result = Group.query()
          .where(group => {
            return group.id === groupId;
          })
          .first();
        groups.push(result);
      });
    }

    return groups;
  }

  get topics() {
    const topics = [];

    Topic.query()
      .all()
      .map(topic => {
        if (topic.members_collection.includes(this.id)) {
          topics.push(topic.id);
        }
      });

    return topics;
  }

  get lastFeedUpdateCheck() {
    return this.lastFeedUpdate ? moment(this.lastFeedUpdate).format('x') : 0;
  }
}
